import {useLocation} from "react-router-dom";
import routes from "routes";
import {useContextProfile} from "context";
import {useEffect} from "react";

export const useNavigation = (
    callback?: () => void
) => {
    const {pathname} = useLocation();
    const {userData, unreadActivities} = useContextProfile();

    useEffect(() => {
        callback?.();
    },[pathname])

    const checkIfActive = (url: string) => (pathname.includes(url) ? true : false);

    const items = userData?.type === 'admin' 
    ? [
        {
            name: "Dashboard",
            link: "/admin/"+routes.admin.main,
            icon: "home",
            isActive: checkIfActive(routes.admin.main)
        },
        {
            name: "Scraping Workers",
            link: "/admin/"+routes.admin.workers,
            icon: "computer",
            isActive: checkIfActive(routes.admin.workers)
        },
        {
            name: "Scraping Logs",
            link: "/admin/"+routes.admin.logs,
            icon: "more",
            isActive: checkIfActive(routes.admin.logs)
        },
        {
            name: "Users",
            link: "/admin/"+routes.admin.users,
            icon: "account",
            isActive: checkIfActive(routes.admin.users)
        },
        {
            name: "Cases",
            link: "/admin/"+routes.admin.cases,
            icon: "cases",
            isActive: checkIfActive(routes.admin.cases)
        },
        {
            name: "Privacy Policy",
            link: "/admin/"+routes.admin.privacyPolicy,
            icon: "lock",
            isActive: checkIfActive(routes.admin.privacyPolicy)
        },
        {
            name: "Terms Of Use",
            link: "/admin/"+routes.admin.termsOfUse,
            icon: "lock",
            isActive: checkIfActive(routes.admin.termsOfUse)
        },
        {
            name: "Settings",
            link: "/admin/"+routes.admin.settings,
            icon: "settings",
            isActive: checkIfActive(routes.admin.settings)
        },
        {
            name: "API Docs",
            link: process.env.REACT_APP_API_HOST+ "/docs",
            icon: "external-link",
            isActive: false
        }
    ] : [
        {
            name: "Activity",
            link: routes.activity.main,
            icon: "activity",
            isActive: checkIfActive(routes.activity.main),
            hasUnread: unreadActivities ? !!unreadActivities : false
        },
        {
            name: "Cases",
            link: routes.cases.main,
            icon: "cases",
            isActive: checkIfActive(routes.cases.main)
        },
        {
            name: "Account",
            link: routes.account.main,
            icon: "account",
            isActive: checkIfActive(routes.account.main)
        }
    ];

    return {
        items,
    }
}